module.exports = __webpack_public_path__ + "img/head.a9944500.png";